import React, { Component } from 'react';
import { Field } from 'redux-form';
import { renderTextField } from '../ReduxFormFields/utils/fields'
import {
  required,
} from '../utilities/fieldValidate'

class OTP extends Component {

  handleClick=()=>{
    this.props.editClick()
  }

  render() {
    return (
      <div style={
        {
          width: '100%',
          justifyContent: 'center',
        }
      }
        className='flex-horizontal'>
        <div>
          <Field
            name='otp'
            type='tel'
            component={renderTextField}
            floatingLabelText='Enter OTP'
            maxLength='4'
            autoComplete='off'
            // validate={[required]}
          />
          <span className='edit-otp-btn' onClick={this.handleClick}>Edit Phone Number</span>
        </div>
      </div>
    );
  }
}

export default OTP


// WEBPACK FOOTER //
// ./src/ReduxFormFields/OTP.js